export const ActivateSubscriptionSuccessModal: string = 'ActivateSubscriptionSuccessModal';
